module.exports = __webpack_public_path__ + "static/eye-c3e55845a64a5e06af6a19b168b38412.png";